import styled from 'styled-components';
import { Button } from '../../../input/Button';
import { Box } from '../../../layout/Box';
import { Flex } from '../../../layout/Flex';
import { MediaCover } from '../../../media/MediaCover';
import { Typography } from '../../../typography/Typography';
import {
    BUTTON_HEIGHT_PRODUCT_EXPANDED,
    BUTTON_WIDTH_EXPANDED_INDENTION,
    MEDIA_ITEM_OFFSET,
    PRODUCT_CONTAINER_WIDTH_INTENTION,
    PRODUCT_CONTENT_WIDTH_INTENTION,
    PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION,
} from './constants';

interface ProductContainerProps {
    isProductExpanded: boolean;
}

export const ProductContainer = styled(Flex).attrs((props) => ({
    ...props,
    width: `calc(100% - ${PRODUCT_CONTAINER_WIDTH_INTENTION}px)`,
    height: '100%',
    direction: 'row',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    left: 1,
}))<ProductContainerProps>`
    opacity: ${({ isProductExpanded }) => (isProductExpanded ? 1 : 0)};
`;

export const ProductContent = styled(Flex).attrs((props) => ({
    ...props,
    direction: 'row',
    alignItems: 'center',
    width: `calc(100% - ${PRODUCT_CONTENT_WIDTH_INTENTION}px)`,
}))``;

interface ProductTextContainerProps {
    indexOffset?: number;
}

export const ProductTextContainer = styled(Flex).attrs((props) => ({
    ...props,
    height: 30,
    ml: 1,
    justifyContent: 'space-between',
    position: 'relative',
    maxWidth: `calc(100% - ${PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION}px)`,
}))<ProductTextContainerProps>`
    left: ${({ indexOffset = 0 }) => indexOffset && `-${MEDIA_ITEM_OFFSET * indexOffset}px`};
`;

export const ProductTitle = styled(Typography).attrs((props) => ({
    ...props,
    weight: 'regular',
    variant: 'caption',
    color: 'black',
    overflow: 'hidden',
    width: '100%',
    textTransform: 'none',
}))`
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface ProductMediaCoverProps {
    index?: number;
}

export const ProductMediaCover = styled(MediaCover).attrs((props) => ({
    ...props,
    ratio: 1,
    height: 40,
    minWidth: 40,
    width: 40,
    borderRadius: 1,
    position: 'relative',
    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
}))<ProductMediaCoverProps>`
    left: ${({ index = 0 }) => index && `-${MEDIA_ITEM_OFFSET * index}px`};
    z-index: ${({ index = 0 }) => index && `-${index}`};
`;

export const MainButton = styled(Button).attrs((props) => ({
    ...props,
    as: 'a',
    target: '_blank',
    rel: 'nofollow noreferrer',
    flexGrow: 1,
    color: 'hardLight',
    width: '100%',
    height: '100%',
    borderRadius: 2,
}))``;

interface ButtonBoxProps {
    isExpanded: boolean;
    isProductExpanded?: boolean;
}

export const ButtonBox = styled(Box).attrs((props) => ({
    ...props,
    position: 'absolute',
    bottom: 0,
    right: 2,
    pointerEvents: 'auto',
    cursor: 'pointer',
    overflow: 'hidden',
    borderRadius: 2,
    width: 117,
    height: 32,
}))<ButtonBoxProps>`
    will-change: border-radius;
    width: ${({ isExpanded, isProductExpanded = false }) =>
        (isExpanded || isProductExpanded) && `calc(100% - ${BUTTON_WIDTH_EXPANDED_INDENTION}px)`};
    height: ${({ isProductExpanded = false }) =>
        isProductExpanded && `${BUTTON_HEIGHT_PRODUCT_EXPANDED}px`};
`;

interface ProductMinizeButtonProps {
    isProductExpanded: boolean;
}

export const ProductMinizeButton = styled(Flex).attrs((props) => ({
    ...props,
    alignItems: 'center',
    justifyContent: 'space-between',
    direction: 'row',
}))<ProductMinizeButtonProps>`
    opacity: ${({ isProductExpanded }) => (isProductExpanded ? 0 : 1)};
`;
